import React from 'react'

import { CanBeAnything } from '../../../types'
import { ReactComponent as Success } from '../../../assets/svgs/success.svg'
import { ReactComponent as Warning } from '../../../assets/svgs/warning.svg'
import { ReactComponent as Error } from '../../../assets/svgs/error.svg'
import { t } from '../../../utils/i18n'
import './asset-meta-card.scss'
import { getFailedSyncMsg, getNextSyncDate } from '../../../containers/utils'
import { InfoTooltip } from '../../atoms/info-tooltip/info-tooltip'

export interface AssetDetailInfo {
  label: string
  [key: string]: CanBeAnything
}

interface AssetMetaCardProps {
  detail: AssetDetailInfo
}

export const AssetMetaCard = ({ detail }: AssetMetaCardProps) => {
  const nextSyncAt = getNextSyncDate(detail)
  const capitalizedStatus =
    detail?.status?.charAt(0)?.toUpperCase() + detail?.status?.slice(1)?.toLowerCase()

  const renderIcon = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'success':
        return <Success />
      case 'failed':
        return (
          <InfoTooltip
            styleClass="input-info"
            tooltipContent={getFailedSyncMsg(detail)}
            placement={'left'}
            followCursor={true}
            delay={300}
          >
            <Error style={{ width: '1.3rem', height: '1.3rem' }} />
          </InfoTooltip>
        )
      case 'in_progress':
        return <Warning />
      default:
        return '-'
    }
  }
  return (
    <div className={`${detail.label} card-wrapper`}>
      <div className="top">
        {renderIcon(detail.status)}
        <p className="body-xs-bold">{t(detail.label)}</p>
      </div>
      <span className="body-xs">
        {t('meta.info')
          .replace('{{status}}', capitalizedStatus)
          .replace('{{nextSyncAt}}', nextSyncAt)}
      </span>
    </div>
  )
}
